(() => {
 function initialize(root=document){
  root.querySelectorAll('[data-studio-hero]').forEach(hero=>{
   if(hero.dataset.initialized)return;hero.dataset.initialized='true';
   hero.querySelectorAll('[data-hero-controls]').forEach(control=>{control.hidden=false;});
   hero.addEventListener('click',event=>{
    const button=event.target.closest('[data-hero-target]');if(!button||button.getAttribute('aria-pressed')==='true')return;
    const target=button.dataset.heroTarget;
    hero.querySelectorAll('[data-hero-slide]').forEach(slide=>{slide.hidden=slide.dataset.heroSlide!==target;if(!slide.hidden){slide.querySelector(`[data-hero-target="${target}"]`)?.focus({preventScroll:true});window.VyborMotion?.dialog(slide);}});
   });
  });
  window.VyborMotion?.reveal(root.querySelectorAll('.collection-card,.collections-section .section-heading,.closing-section'));
 }
 initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
 document.addEventListener('shopify:block:select',event=>{const selected=event.target.closest('[data-hero-slide]');if(selected)selected.closest('[data-studio-hero]').querySelectorAll('[data-hero-slide]').forEach(slide=>{slide.hidden=slide!==selected;});});
 document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.studio-mobile-navigation[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});});
 document.addEventListener('click',event=>document.querySelectorAll('.studio-mobile-navigation[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;}));
})();
